import { FormFieldTextArea } from 'Components/FormField/FormFieldTextArea/FormFieldTextArea';
import { UnansweredQuestionMarker } from 'Components/RequiresAttentionMarker/UnansweredQuestionMarker';
import { Text, TextProps } from 'Components/Text/Text';
import { IrqQuestionFreeformText, IrqQuestionType } from 'Models/InherentRisk';

interface QuestionFreeformTextProps {
    formFieldId: string;
    onAnswerChanged: (text: string) => void;
    question: IrqQuestionFreeformText;
    questionNumber: number;
    showUnansweredQuestionMarker: boolean;

    disabled?: boolean;
    questionTextVariant?: TextProps['variant'];
}

/**
 * Renders a question that requires the user to input freeform text.
 * Currently used only for the IRQ.
 */
export const QuestionFreeformText = (props: QuestionFreeformTextProps) => {
    return (
        <>
            <Text variant={props.questionTextVariant ?? 'Text2'}>{`${props.questionNumber}. ${props.question.text}`}</Text>
            {props.showUnansweredQuestionMarker && <UnansweredQuestionMarker questionIsRequired questionType={IrqQuestionType.FREEFORM_TEXT} />}
            <FormFieldTextArea formFieldLabel="Answer" formFieldId={props.formFieldId} handleChange={(event: React.FormEvent<HTMLInputElement>) => props.onAnswerChanged(event.currentTarget.value)} value={props.question.answer ?? ''} />
        </>
    );
};
